import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'promote',
		path: ['/p/:slug/promote', '/p/:slug/sponsors/new'],
		component: loadable(async () => import(/* webpackChunkName: "pages/psf_promote" */ './index'), {
			exportName: 'Promote',
			fallback: Loading,
		}),
		frame: false,
		ssr: {
			enabled: true,
			seo: false,
		},
	},
];
